import React, { useMemo } from 'react';

import Option from './Option';
import { SelectOption } from '../../types';
import styles from './SelectAllOption.module.scss';

type PassedProps = {
  isSelected: boolean;
  onSelect: (selected: boolean) => void;
  onKeyDown?: (e: React.KeyboardEvent<HTMLLIElement>) => void;
  optionRef?: React.Ref<HTMLLIElement>;
};

export type SelectAllOptionProps = {
  /** Label for `Select all` functionality when `multiple` prop is true */
  label?: string;
};

const SelectAllOption = ({
  label = 'Select all',
  ...passedProps
}: SelectAllOptionProps) => {
  const { isSelected, onSelect, optionRef, onKeyDown } =
    passedProps as PassedProps;

  const selectAllOption: SelectOption = useMemo(
    () => ({
      value: Date.now(),
      label,
    }),
    [label],
  );

  return (
    <Option
      optionRef={optionRef}
      highlightedText=""
      onSelect={() => onSelect(!isSelected)}
      onKeyDown={onKeyDown}
      option={selectAllOption}
      optionStyle="checkbox"
      optionType="single-line"
      selected={isSelected}
      className={styles.selectAllOption}
    />
  );
};

export default SelectAllOption;
